import { useState } from "react";

import { Nav, Hamburger, Menu, MenuLink, Logo } from './NavbarElements'

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Nav>
      <Logo to="/"><img src="./images/HomePageLogo.png" alt="" /><span>Fluxo de Vacinação</span></Logo>
      <Hamburger onClick={() => setIsOpen(!isOpen)}>
        <span />
        <span />
        <span />
      </Hamburger>
      <Menu isOpen={isOpen}>
        <MenuLink to="/">Inicio</MenuLink>
        {/* <MenuLink to="/videos">Videos</MenuLink> */}
        <MenuLink to="/rankings">Rankings</MenuLink>
        <MenuLink to="/sobre">Sobre</MenuLink>
      </Menu>
    </Nav>
  );
};